import gql from 'graphql-tag';
export default gql`
  mutation CreatePhone($input: CreatePhoneInput!) {
    createPhone(input: $input) {
      clientMutationId
    }
  }
`;
